import { lazy } from "react"
import type { OysterRouter } from "~/router/type"
import { LazyLoadingSuspenseWithErrorBoundary } from "@oysterhr/feature-components"

const OvertimeDetailsPage = lazy(() => import("./pages/OvertimeDetailsPage"))

export const staffHiringFTERoutes: OysterRouter = {
  DeprecatedLeftSidebar: [
    {
      children: [
        {
          path: "companies/:companyStrongId/employments/:employmentStrongId/overtime-details",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <OvertimeDetailsPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
      ],
    },
  ],
}
